import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/tinkerlabs__web__logo.webp';

const Footer = ({toSection,section}) => {
  const menuItems = [
    {
      title: "About Us",
      links: [
         { name: "Contact", href: "/#contact-form" },
        { name: "Own a Franchise", href: "https://tinkerlabs.org/franchise" },
      ]
    },
    {
      title: "Locations",
      links: [
        { name: "Austria", href: "https://tinkerlabs.at" },
        { name: "Bosnia and Herzegovina", href: "https://tinkerlabs.ba" },
        { name: "Canada", href: "https://tinkerlabs.ca" },
        { name: "Croatia", href: "https://tinkerlabs.hr" },
        { name: "Germany", href: "https://tinker-labs.de" },
        { name: "Hungary", href: "https://tinkerlabs.hu" },
        { name: "Macedonia", href: "https://tinkerlabs.mk" },
        {name:"Montenegro", href: "https://tinker-labs.me"},
        { name: "Poland", href: "https://tinkerlabs.pl" },
        { name: "Romania", href: "https://tinkerlabs.ro" },
        { name: "Serbia", href: "https://tinkerlabs.rs" },
        { name: "Slovenia", href: "https://tinkerlabs.si" },
        { name: "UK", href: "https://tinkerlabs.uk" },
      ]
    },
    {
      title: "Connect",
      links: [
        { name: "Facebook", href: "https://www.facebook.com/tinkerlabsinternational/" },
        { name: "Instagram", href: "https://www.instagram.com/tinkerlabsinternational/" },
        { name: "LinkedIn", href: "https://www.linkedin.com/company/tinker-labs-doo/?originalSubdomain=hr" },
      ]
    }
  ];

  return (
    <footer id={section} className="bg-[#A064B4] text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo Column */}
          <div className="mb-8 md:mb-0">
            <img 
              src={logo} 
              alt="Tinker Labs Logo" 
              className="w-48 h-auto mb-4"
            />
            <p className="text-sm font-['Lexend']  mt-4">
              Inspiring EUREKA Moments through creative and interactive STEAM activities
            </p>
          </div>

          {/* Menu Columns */}
          {menuItems.map((section, index) => (
            <div key={index}>
              <h3 className="font-['Grandstander'] text-xl font-bold mb-4">
                {section.title}
              </h3>
              <ul className="space-y-2">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <a 
                      href={link.href}
                      className="font-['Lexend'] text-sm hover:text-white/80 transition-colors duration-200"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 mt-12 pt-8 text-sm font-['Lexend']">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p>© {new Date().getFullYear()} Tinker Labs. All rights reserved.</p>
            <div className="mt-4 md:mt-0 space-x-6">
              <a href="https://tinkerlabs.org/privacy-policy" target="_blank" className="hover:text-white/80 transition-colors duration-200">
                Privacy Policy
              </a>
              <a href="https://tinkerlabs.org/terms-of-service" target="_blank"  className="hover:text-white/80 transition-colors duration-200">
                Terms of Service
              </a>
              <a href="https://tinkerlabs.org/cookie-policy" target="_blank" className="hover:text-white/80 transition-colors duration-200">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;